/*
 *
 * BackbookUserNotRegisteredModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.recovery.backbook.modal.title'
      defaultMessage='Registrati al nuovo portale<br/> Merchant Portal'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.recovery.backbook.modal.description'
      defaultMessage='Da oggi potrai accedere al nuovo Merchant Portal con nuove credenziali scelte da te.<br/> Le credenziali che hai utilizzato finora, fornite dalla Banca al momento della sottoscrizione del contratto in Agenzia, non possono più essere utilizzate a questo portale.'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.recovery.backbook.modal.buttonLabel'
      defaultMessage='Registrati subito'
    />
  )
}

export default formattedMessage
